import { render } from "./CZHistoricConsumptionCo2Gas.vue?vue&type=template&id=ff5e707a&scoped=true&ts=true"
import script from "./CZHistoricConsumptionCo2Gas.vue?vue&type=script&lang=ts"
export * from "./CZHistoricConsumptionCo2Gas.vue?vue&type=script&lang=ts"

import "./CZHistoricConsumptionCo2Gas.vue?vue&type=style&index=0&id=ff5e707a&scoped=true&lang=css"

import exportComponent from "C:\\Develop\\Czone_UI_EIC\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff5e707a"]])

export default __exports__